$('.schedule_inner').each(function () {
  // 時刻表のヘッダーの高さを調整します
  var $headerItem = $(this).find('.schedule_header').find('.schedule_hours,.schedule_minutes');
  scheduleHeaderHeight($headerItem);

  // 時刻表の高さを調整します
  var l = $(this).find('.weekdays_schedule .schedule_hour').length;
  for (let i = 0; i < l; i++) {
    var h = 0;
    $(this).find('.hour_' + i).each(function () {
      if (h < $(this).innerHeight()) {
        h = $(this).innerHeight();
      }
    });
    $(this).find('.hour_' + i).css({
      height: h + 'px'
    });
  }
});

function scheduleHeaderHeight ($headerItem) {
  // 時刻表のヘッダーの高さを調整します
  var headerheight = 0;
  $headerItem.each(function () {
    if (headerheight < $(this).innerHeight()) {
      headerheight = $(this).innerHeight();
    }
  });
  $headerItem.each(function () {
    $(this).css({
      height: headerheight + 'px'
    });
  });
}

/* ==============================
  路線全体の時刻表
  =============================== */
$('.scheduleAll').each(function () {
  // 枠の高さ
  var thisheight = $(this).height();
  $(this).css({ height: thisheight + 'px' });
  // 高さを調整
  var l = $(this).find('.scheduleAll_header_item').length;
  for (let i = 0; i < l; i++) {
    var h = 0;
    $(this).find('.row-' + i).each(function () {
      if (h < $(this).innerHeight()) {
        h = $(this).innerHeight();
      }
    });
    $(this).find('.row-' + i).css({
      height: h + 'px'
    });
  }
  // 左のパディングを調整
  var w = $(this).find('.scheduleAll_header').width();
  $(this).css({
    paddingLeft: w + 'px'
  });
});
